import { FormField } from '@/global/components';
import { Button, Input } from '@/lib';
import { usePasswordRecoveryMutation } from '@/services/endpoints/users';
import { zodResolver } from '@hookform/resolvers/zod';
import { FC } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { RESET_PASSWORD_FORM_SCHEMA, ResetPasswordFormInput, ResetPasswordFormOutput } from './formSchema';

type ResetPasswordFormProps = {
  onPasswordRecoverySent: VoidFunction;
};

export const ResetPasswordForm: FC<ResetPasswordFormProps> = ({ onPasswordRecoverySent }) => {
  const { t } = useTranslation();
  const { handleSubmit, register } = useForm<ResetPasswordFormInput, unknown, ResetPasswordFormOutput>({
    resolver: zodResolver(RESET_PASSWORD_FORM_SCHEMA),
  });

  const [recoveryPassword, { isLoading }] = usePasswordRecoveryMutation();

  const onSubmit: SubmitHandler<ResetPasswordFormOutput> = async ({ email }) => {
    await recoveryPassword({ email });
    onPasswordRecoverySent();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className='grid w-full justify-items-center gap-6'>
      <FormField label={'users:email'}>
        <Input {...register('email')} />
      </FormField>
      <Button type='submit' isLoading={isLoading} text={t('ALL:requestNewPassword')} className='w-full' />
    </form>
  );
};
